module.exports = __webpack_public_path__ + "static/media/naama.ccad080e.png";